<template>
  <div class="panel-item">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>{{ name }}招商排行</div>
      <div style="display: flex;gap: 10px;">
        <div class="title_name_r" @click="openDetail">详情 ></div>
      </div>
    </div>
    <dv-scroll-board :config="config" class="panel-item_datav"/>
    <ListDialog :detail="detail" :form.sync="form" @close="close" :visible="detailVisible"></ListDialog>
  </div>
</template>

<script>
import ListDialog from './InvestmentRankDialog.vue'
import {tFormatDate} from '@/utils/utils';

export default {
  components: {
    ListDialog
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    rankblock: {
      type: Array,
      default: () => []
    },
    institution_partner_detail_rank_block: {
      type: Object,
    },
    form: {
      type: Object,
      default: {}
    },
    sendMessage: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      config: {
        header: ['排名', '招商机构昵称', '申样审核'],
        data: [],
        headerBGC: '#053355',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        headerHeight: 30,
        hoverPause: true,
        // waitTime: 99999999,
        columnWidth: [60,240,100], // 调整列宽，中间列为产品名称宽度
        align: ['left', 'center', 'center'],
      },
      detailVisible: false,
      detail: {},

      isOneBgc: false,// 是 单兵工场 页
    }
  },
  mounted() {
    this.form.module_user_id = this.$route.query.bgcId
    if (this.$route.query.bgcId) {
      this.isOneBgc = true
    }
  },
  methods: {
    close() {
      delete this.form.fx_user_date_start
      delete this.form.fx_user_date_end
      delete this.form.fx_user_page
      delete this.form.fx_user_no
      this.$emit('update:form', {
        ...this.form,
        position: 0
      });
      this.detailVisible = false
    },
    // 打开详情
    openDetail() {
      let tStart
      let tEnd
      if (this.form.date_type == 0) {
        tStart = ''
        tEnd = ''
        // 今日
        if (this.form.date_value == 1) {
          tStart = tFormatDate(new Date(), 'YYYY-MM-DD')
          tEnd = tFormatDate(new Date(), 'YYYY-MM-DD')
        }
        // 昨日
        if (this.form.date_value == 2) {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          tStart = tFormatDate(yesterday, 'YYYY-MM-DD');
          tEnd = tFormatDate(yesterday, 'YYYY-MM-DD');
        }
        // 本月
        if (this.form.date_value == 3) {
          const now = new Date();
          const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
          tStart = tFormatDate(firstDay, 'YYYY-MM-DD');
          tEnd = tFormatDate(now, 'YYYY-MM-DD');
        }
        // 上月
        if (this.form.date_value == 4) {
          const now = new Date();
          const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          const lastDayOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
          tStart = tFormatDate(firstDayOfLastMonth, 'YYYY-MM-DD');
          tEnd = tFormatDate(lastDayOfLastMonth, 'YYYY-MM-DD');
        }
      }
      // 自定义时间
      if (this.form.date_type == 1) {
        tStart = this.form.date_start
        tEnd = this.form.date_end
      }
      this.form.fx_user_page = 1
      this.form.fx_user_no = ''

      this.$emit('update:form', {
        ...this.form,
        position: 2,
        fx_user_date_start: tStart,
        fx_user_date_end: tEnd,
        fx_user_page: 1,
        fx_user_no: '',
      });
      this.sendMessage();
      this.detailVisible = true
    },
    dialogTimeCg(tStart, tEnd) {
      this.$emit('update:form', {
        ...this.form,
        fx_user_date_start: tStart,
        fx_user_date_end: tEnd,
        fx_user_page: 1,
        fx_user_no: '',
      });
      this.sendMessage();
    },
    dialogPageCg(page) {
      this.$emit('update:form', {
        ...this.form,
        fx_user_page: page,
      });
      this.sendMessage();
    },
    dialogFxzCg(no) {
      this.$emit('update:form', {
        ...this.form,
        fx_user_page: 1,
        fx_user_no: no,
      });
      this.sendMessage();
    },

  },
  watch: {
    rankblock: {
      immediate: true,
      handler(newVal) {
        const newData = newVal.map((item, index) => [
          `<div class="index${index} left_box">${index > 2 ? index + 1 : ''}</div>`,
          // 昵称列
          item.institution_partner_name || '',
          `<div  class="right_box" >${item.count_audit || '0'}</div>`
        ])

        this.config = Object.assign({}, this.config, {
          data: newData
        })
      }
    },
    institution_partner_detail_rank_block: {
      immediate: true,
      handler(newVal) {
        this.detail = newVal
        console.log('组件的消息', this.detail)
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.title_name {
  padding: 30px 40px 23px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}

.title_name_r {
  cursor: pointer;
  margin-top: 5px;
  font-weight: 400;
  font-size: 18px;
  color: #FFCC00;
}

.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.panel-item_datav {
  padding: 0 30px 30px 30px;
  width: 426px;
  height: 290px;
}


::v-deep .header {
  // background: #053355 !important;
  // height: 38px !important;
  // line-height: 38px !important;
  color: #fff; // Added for better visibility
  font-weight: bold;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
}

::v-deep .header-item {
  // height: 38px !important;
  // line-height: 38px !important;
  font-size: 18px;
}

::v-deep .row-item {

  height: 51px;
  line-height: 52px;
  color: #eee; // Added for better visibility
  font-size: 18px;
  border-bottom: 1px dashed rgba(255, 255, 255, .2);

}

::v-deep .ceil {
  text-align: center;
  // height: 51px !important;
  // line-height: 51px !important;
  padding: 0 10px;
  font-size: 18px;
}

::v-deep .index0 {
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking1.png) !important;
  background-size: 30px 34px !important;
}

::v-deep .index1 {
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking2.png) !important;
  background-size: 30px 34px !important;
}

::v-deep .index2 {
  line-height: 34px;
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking3.png) !important;
  background-size: 30px 34px !important;
}

::v-deep .left_box {
  line-height: 36px !important;
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking.png);
  background-size: 30px 34px;
}

::v-deep .right_box {
  width: 80%;
  height: 24px;
  line-height: 24px;
  background: #00BAFF;
  font-weight: bold;
  color: #06162A;
  transform: translate(10%, 60%);
}
</style>